import { DenialCodeMapService } from '@/services/pa/denial-code-map.service';

import { PA_SAVE_DENIAL_CODE_MAP, PA_GET_DENIAL_CODE_MAP, PA_SEARCH_DENIAL_CODE_MAP, PA_DELETE_DENIAL_CODE_MAP } from './actions.type';
import { SET_PA_GET_DENIAL_CODE_MAP_COMPLETE, SET_PA_SEARCH_DENIAL_CODE_MAP_COMPLETE, SET_PA_SEARCH_DENIAL_CODE_MAP_EXPORT_COMPLETE, SET_PA_DENIAL_CODE_MAP_BUSY } from './mutations.type';
import { ERROR_HANDLE_ERROR, ERROR_CLEAR_ERROR } from '../error/actions.type';

const initialState = {
    isBusy: false,
    currentDenialCodeMap: '',
    searchResults: [],
    exportSearchResults: []
};

export const state = Object.assign({}, initialState);

export const actions = {
    [PA_SAVE_DENIAL_CODE_MAP](context, body) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, true);
        var promise = null;
        if (body.denial_code_map_id) {
            promise = DenialCodeMapService.put(body.denial_code_map_id, body);
        } else {
            promise = DenialCodeMapService.post(body);
        }
        promise.then((data) => {
            context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, false);
            if (data.errorMessage) {
                context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
            }
            return data;
        },
            (err) => {
                context.dispatch(ERROR_HANDLE_ERROR, err);
                context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, false);
            });

        return promise;
    },
    [PA_DELETE_DENIAL_CODE_MAP](context, body) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, true);
        return DenialCodeMapService.delete(body.denial_code_map_id, body).then((data) => {
            context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, false);
            if (data.errorMessage) {
                context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
            }
            return data;
        },
            (err) => {
                context.dispatch(ERROR_HANDLE_ERROR, err);
                context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, false);
            });
    },
    [PA_GET_DENIAL_CODE_MAP](context, body) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, true);
        return DenialCodeMapService.get(body.denial_code_map_id)
            .then((data) => {
                context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_PA_GET_DENIAL_CODE_MAP_COMPLETE, data);
                }
                return data;
            },
                (err) => {
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                    context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, false);
                });
    },
    [PA_SEARCH_DENIAL_CODE_MAP](context, criteria) {
        context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, true);
        var promise = null;

        promise = DenialCodeMapService.search(criteria);
        promise.then((data) => {
            context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, false);
            if (data.errorMessage) {
                context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
            } else {
                if (criteria.export !== undefined) {
                    context.commit(SET_PA_SEARCH_DENIAL_CODE_MAP_EXPORT_COMPLETE, data);
                } else {
                    context.commit(SET_PA_SEARCH_DENIAL_CODE_MAP_COMPLETE, data);
                }
            }
            return data;
        },
            (err) => {
                context.dispatch(ERROR_HANDLE_ERROR, err);
                context.commit(SET_PA_DENIAL_CODE_MAP_BUSY, false);
            });

        return promise;
    }
};

const getters = {};

export const mutations = {
    [SET_PA_GET_DENIAL_CODE_MAP_COMPLETE](state, results) {
        state.currentDenialCodeMap = results;
    },
    [SET_PA_SEARCH_DENIAL_CODE_MAP_COMPLETE](state, results) {
        state.searchResults = results;
    },
    [SET_PA_SEARCH_DENIAL_CODE_MAP_EXPORT_COMPLETE](state, results) {
        state.exportSearchResults = results;
    },
    [SET_PA_DENIAL_CODE_MAP_BUSY](state, results) {
        state.isBusy = results;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/denial-code-map/denial-code-map.module.js